import { I18nKey } from '@/i18n/types';
import { WeatherType } from '@/types';

export const weatherTypeMap: Record<WeatherType, I18nKey['common']> = {
  PARTLY_CLOUDY: 'resort.weather.partlyCloudy',
  CLOUDY: 'resort.weather.cloudy',
  RAIN: 'resort.weather.rain',
  SNOW: 'resort.weather.snow',
  LIGHT_RAI: 'resort.weather.lightRain',
  SLEET: 'resort.weather.sleet',
  FOG: 'resort.weather.fog',
  SUN: 'resort.weather.sunny',
  SUNNY: 'resort.weather.sunny',
  FAIR: 'resort.weather.fair',
  RAIN_SHOWERS: 'resort.weather.rainShowers',
  SLEET_SHOWERS: 'resort.weather.sleetShowers',
  SNOW_SHOWERS: 'resort.weather.snowShowers',
  OVERCAS: 'resort.weather.overcast',
  SLIGHTLY_CLOUDY: 'resort.weather.slightlyCloudy',
  MOSTLY_SUNNY: 'resort.weather.mostlySunny',
  LUNE: 'resort.weather.lune',
  THUNDERSTORM: 'resort.weather.thunderstorm',
};
